import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
    formGrid: {
        display: "grid",
        gridTemplateColumns: "1fr",
        gap: 10,
        justifyItems: "center",
        justifyContent: "center",
        alignContent: "center",
        ["@media screen and (min-width:1400px)"]: {
            gridTemplateColumns: "repeat(3, 1fr)"
          }
    },
    errorGrid: {
        marginLeft: 24,
        marginRight: 24
    },
    error: {
        textAlign: "center",
        color: "red"
    },
    searchButton: {
        backgroundColor: "#3474b4",
        color: "white",
        width: 300,
        margin: "10px auto 0px",
        padding: 8,
        position: "relative",
        textTransform: "none",
        fontWeight: 400,
        "&:hover": {
            backgroundColor: "#3474b4"
        }
    }
});